"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _AllowedHeaders_1 = require("./_AllowedHeaders");
var _AllowedMethods_1 = require("./_AllowedMethods");
var _AllowedOrigins_1 = require("./_AllowedOrigins");
var _ExposeHeaders_1 = require("./_ExposeHeaders");
exports._CORSRule = {
    type: "structure",
    required: ["AllowedMethods", "AllowedOrigins"],
    members: {
        AllowedHeaders: {
            shape: _AllowedHeaders_1._AllowedHeaders,
            locationName: "AllowedHeader"
        },
        AllowedMethods: {
            shape: _AllowedMethods_1._AllowedMethods,
            locationName: "AllowedMethod"
        },
        AllowedOrigins: {
            shape: _AllowedOrigins_1._AllowedOrigins,
            locationName: "AllowedOrigin"
        },
        ExposeHeaders: {
            shape: _ExposeHeaders_1._ExposeHeaders,
            locationName: "ExposeHeader"
        },
        MaxAgeSeconds: {
            shape: {
                type: "integer"
            }
        }
    }
};
//# sourceMappingURL=_CORSRule.js.map